/**
 * Copyright (c) 2019, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import NotificationDropdown from './NotificationDropdown';

// Styled Components Definitons START
const CountDot = styled.div`
  position: absolute;
  top: -.1rem;
  right: -.3rem;
  border-radius: 0.5rem;
  width: 12px;
  height: 12px;
  border: solid 0.5px #ffffff;
  background-color: #ee5e5e;
  @media (max-width: 1023px) {
    top: -.5rem;
    right: -.5rem;
    width: 1rem;
    height: 1rem;
    border: solid 1px #ffffff;
  }
`;

const CounterLabel = styled.span`
  width: 0.75rem;
  height: 0.75rem;
  font-size: 0.5625rem;
  font-weight: bold;
  text-align: center;
  color: #ffffff;
  line-height: 1.33;
  display: table-cell;
  @media (max-width: 1023px) {
    width: 1rem;
    height: 1rem;
    font-size: 0.75rem;
    text-align: center;
    line-height: 1;
  }
`;

const Wrapper = styled.div`
  @media (max-width: 1023px) {
    margin-left: 1.5rem;
    margin-right: .5rem;
  }

  position: relative;
`;
// Styled Components Definitons END

/**
 * NotificationIcon component
 * This component displays an icon, which when clicked can show messages in a popover window
 * Additionally, you can show a reddot, and the number of notifications.
 */
class NotificationIcon extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popupVisible: false
    };
  }

  handleClick = () => {
    this.setState({ popupVisible: !this.state.popupVisible });
  };

  handleCloseButtonClick = () => {
    this.setState({
      popupVisible: !this.state.popupVisible
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.notificationCount !== nextProps.notificationCount) {
      this.setState({
        popupVisible: nextProps.notificationCount > 0
      });
    }
  }

  render() {
    const {
      iconElement,
      notificationProps,
      notificationCount,
      showRedDot,
      showCount,
      showDropDown,
      targetUrl,
      linkTitle
    } = this.props;

    return (
      <Wrapper>
        <div
          ref={node => {
            this.node = node;
          }}
          onClick={this.handleClick}
        >
          <Link to={targetUrl} title={linkTitle}>{iconElement}</Link>
          {showRedDot && (
            <CountDot>
              {showCount && <CounterLabel> {notificationCount} </CounterLabel>}
            </CountDot>
          )}
        </div>
        {showDropDown && this.state.popupVisible && (
          <NotificationDropdown
            {...notificationProps}
            notificationCount={notificationCount}
            onCloseButtonClick={this.handleCloseButtonClick}
          />
        )}
      </Wrapper>
    );
  }
}

NotificationIcon.propTypes = {
  iconElement: PropTypes.object,
  notificationProps: PropTypes.object,
  notificationCount: PropTypes.number,
  showRedDot: PropTypes.bool,
  showCount: PropTypes.bool,
  showDropDown: PropTypes.bool,
  targetUrl: PropTypes.string
};

export default NotificationIcon;
